import { render, staticRenderFns } from "./LessonSelectorImageViewerComponent.vue?vue&type=template&id=5b4806d1&"
import script from "./LessonSelectorImageViewerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonSelectorImageViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonSelectorImageViewerComponent.vue?vue&type=style&index=0&id=5b4806d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports